import { useEffect, useLayoutEffect } from "react"
import { Route, Routes, useLocation, useNavigationType } from "react-router-dom"
import { MarketingLayout } from "~/landing/marketing-layout"
import { trackPageView } from "~/lib/analytics"
import { HackathonsPage } from "~/marketing/hackathons-page"
import { NewsletterUnsubscribePage } from "~/marketing/newsletter-unsubscribe-page"
import { PodsPage } from "~/marketing/pods-page"
import { PublicPage } from "~/marketing/public-page"
import { SessionsPage } from "~/marketing/sessions-page"
import { CaseStudyPage, WorkIndexPage } from "~/marketing/work-pages"

const Analytics = () => {
  const location = useLocation()

  useEffect(() => {
    trackPageView()
  }, [location.pathname, location.search])

  return null
}

const ScrollReset = () => {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useLayoutEffect(() => {
    if (navigationType === "POP") return
    if (hash) {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView()
      return
    }
    window.scrollTo(0, 0)
  }, [pathname, hash, navigationType])

  return null
}

export const MarketingApp = ({
  unsubscribeEmail,
  unsubscribed = false,
}: {
  unsubscribeEmail?: string
  unsubscribed?: boolean
}) => (
  <>
    <Analytics />
    <ScrollReset />
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route
          path="newsletter/unsubscribe"
          element={
            <NewsletterUnsubscribePage email={unsubscribeEmail} unsubscribed={unsubscribed} />
          }
        />
        <Route
          path="founder-course/unsubscribe"
          element={
            <NewsletterUnsubscribePage
              email={unsubscribeEmail}
              unsubscribed={unsubscribed}
              course
            />
          }
        />
        <Route index element={<PublicPage page="home" />} />
        <Route path="pods" element={<PodsPage />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="hackathons" element={<HackathonsPage />} />
        <Route path="work" element={<WorkIndexPage />} />
        <Route path="services" element={<PublicPage page="services" />} />
        <Route path="services/ai-strategy" element={<PublicPage page="ai-strategy" />} />
        <Route path="web-development" element={<PublicPage page="web-development" />} />
        <Route path="services/design" element={<PublicPage page="design" />} />
        <Route path="services/product" element={<PublicPage page="product" />} />
        <Route path="services/sprint-zero" element={<PublicPage page="sprint-zero" />} />
        <Route path="solutions" element={<PublicPage page="solutions" />} />
        <Route path="solutions/early-startups" element={<PublicPage page="early-startups" />} />
        <Route path="solutions/growth-startups" element={<PublicPage page="growth-startups" />} />
        <Route
          path="solutions/small-medium-businesses"
          element={<PublicPage page="small-medium-businesses" />}
        />
        <Route path="solutions/private-equity" element={<PublicPage page="private-equity" />} />
        <Route path="solutions/accelerators" element={<PublicPage page="accelerators" />} />
        <Route path="about" element={<PublicPage page="about" />} />
        <Route path="our-approach" element={<PublicPage page="our-approach" />} />
        <Route path="our-team" element={<PublicPage page="our-team" />} />
        <Route path="contact" element={<PublicPage page="contact" />} />
        <Route path="first-time-founders" element={<PublicPage page="first-time-founders" />} />
        <Route path="privacy" element={<PublicPage page="privacy" />} />
        <Route path="terms" element={<PublicPage page="terms" />} />
        <Route path="work/:slug" element={<CaseStudyPage />} />
      </Route>
    </Routes>
  </>
)
